export default "__VITE_PUBLIC_ASSET__f21b6d8f__"